import { render, staticRenderFns } from "./LicenseDialog.vue?vue&type=template&id=7422101e&scoped=true"
import script from "./LicenseDialog.vue?vue&type=script&lang=js"
export * from "./LicenseDialog.vue?vue&type=script&lang=js"
import style0 from "./LicenseDialog.vue?vue&type=style&index=0&id=7422101e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7422101e",
  null
  
)

export default component.exports